import { createContext, useContext, useState, ReactNode } from "react";
import languageData from "../language.json";

// 🌍 
type LanguageKeys = keyof typeof languageData;

interface LanguageContextType {
  language: string;
  setLanguage: (lang: string) => void;
  t: (section: LanguageKeys, key: string) => string;
}

// 🛡️
const defaultContext: LanguageContextType = {
  language: "en",
  setLanguage: () => {},
  t: () => "",
};

// 📚
const LanguageContext = createContext<LanguageContextType>(defaultContext);

// 🌐
export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguage] = useState<string>("cz");

  // 🔄 
  const t = (section: LanguageKeys, key: string) => {
    const sectionData = languageData[section as keyof typeof languageData];
    const languageDataByKey = sectionData?.[language as keyof typeof sectionData];
    return (languageDataByKey?.[key as keyof typeof languageDataByKey] ||
      key) as string;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};


export const useLanguage = () => {
  return useContext(LanguageContext);
};
